import { LitElement, html, css } from '@hh/global.js'
class HHStickyAtc extends LitElement {
  static properties = {
    'form-id': { type: String },
  }

  constructor() {
    super()
    this._inFlow = false
    this._cooldownUntil = 0
  }

  connectedCallback() {
    super.connectedCallback()
    this._onScroll = this._handleScroll.bind(this)
    this._onClick = this.onAdd.bind(this)
    window.addEventListener('scroll', this._onScroll, { passive: true })
    this.addEventListener('click', this._onClick)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this._onScroll)
    this.removeEventListener('click', this._onClick)
  }

  addStickyAtcOffsetVariable() {
    const container = this.renderRoot.querySelector('.container')
    if (container) {
      this._barHeight = container.offsetHeight
      document.documentElement.style.setProperty(
        '--sticky-atc-height',
        `${container.offsetHeight * 0.1}rem`
      )
    }
  }

  firstUpdated() {
    this.addStickyAtcOffsetVariable()
    window.addEventListener(
      'resize',
      this.addStickyAtcOffsetVariable.bind(this)
    )
    requestAnimationFrame(() => {
      this.addStickyAtcOffsetVariable()
      this._handleScroll()
    })
  }

  _handleScroll() {
    if (Date.now() < this._cooldownUntil) return

    const sentinel = this.renderRoot.querySelector('.sentinel')
    if (!sentinel || this._barHeight == null) return

    const { top } = sentinel.getBoundingClientRect()
    const virtualBottom = top + this._barHeight
    const viewportBottom = window.innerHeight
    const buffer = 40

    if (this._inFlow && virtualBottom > viewportBottom + buffer) {
      this._setSticky()
    } else if (virtualBottom <= viewportBottom) {
      this._setInFlow()
    }
  }

  _setInFlow() {
    this._inFlow = true
    this.classList.add('in-flow')
    this._cooldownUntil = Date.now() + 250
  }

  _setSticky() {
    this._inFlow = false
    this.classList.remove('in-flow')
    this._cooldownUntil = Date.now() + 250
  }

  onAdd(event) {
    const path = event.composedPath?.() ?? [event.target]
    const target = path[0]
    const clickedSelectOption = path.find((el) =>
      el?.classList?.contains?.('js-product-select-option')
    )
    const isActionArea = path.some(
      (el) =>
        el?.classList?.contains?.('product__sticky-bar-actions') ||
        el?.tagName === 'BUTTON'
    )

    if (target?.getAttribute?.('data-notify') === 'true') {
      const backInStock = document.querySelector('hh-back-in-stock')
      backInStock.querySelector('button').click()
      backInStock.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
      return
    }

    if (clickedSelectOption) {
      const section = this.closest('[data-section]')
      const sizeSelector = section?.querySelector('hh-variant-picker') ??
        document.querySelector('hh-variant-picker')
      if (sizeSelector) {
        sizeSelector.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }
      return
    }

    if (isActionArea) {
      document
        .querySelector(`#${this['form-id']}`)
        .querySelector('[name="add"]')
        ?.click()
    }
  }

  render() {
    return html`
      <div class="sentinel" aria-hidden="true"></div>
      <div class="container">
        <div class="inner">
          <slot></slot>
        </div>
      </div>
    `
  }

  static styles = css`
    @media (max-width: 990px) {
      :host {
        display: block;
        position: relative;
      }

      .sentinel {
        position: absolute;
        top: 0;
        left: 0;
        width: 1px;
        height: 1px;
        overflow: hidden;
        pointer-events: none;
        opacity: 0;
      }

      .container {
        --hh-background: #2e2a2b;

        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        background-color: var(--hh-color-reverse, #f7f7f7);
        border-top: var(--hh-border-width, 0.1rem) solid
          var(--hh-border-color, #b8b8b8);
        z-index: var(--hh-z-index, 100);
      }

      :host(.in-flow) .container {
        position: relative;
        left: auto;
        bottom: auto;
        margin-top: 2rem;
        margin-left: -1.5rem;
        width: calc(100% + 3rem);
      }

      .container .inner {
        padding: var(--hh-sticky-padding, 2rem 1.5rem);
      }
    }
  `
}

customElements.define('hh-sticky-atc', HHStickyAtc)
